<template>
  <div class="relative w-full max-w-[600px] mx-auto no-select">
    <!-- Botão Esquerdo -->
    <button
      class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 disabled:bg-gray-300 z-10"
      @click="scrollLeft"
      :disabled="!canScrollLeft"
    >
      ⬅
    </button>

    <!-- Contêiner do Carrossel -->
    <div class="relative w-full overflow-hidden">
      <div
        class="flex transition-transform duration-300"
        :style="{ transform: `translateX(-${scrollOffset}px)` }"
      >
        <div
          v-for="(image, index) in images"
          :key="image.id"
          class="flex-shrink-0 w-[120px] mx-2 transform transition-all duration-300"
          :class="{
            'scale-100 z-10': selectedIndex === index,
            'scale-75 opacity-30': selectedIndex !== index
          }"
          @click="selectImage(index)"
        >
          <img
            :src="image.src"
            :alt="image.name"
            class="w-full rounded-lg cursor-pointer shadow-md"
          />
        </div>
      </div>
    </div>

    <!-- Botão Direito -->
    <button
      class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 disabled:bg-gray-300 z-10"
      @click="scrollRight"
      :disabled="!canScrollRight"
    >
      ➡
    </button>
  </div>
</template>

<style scoped>
/* Adiciona a classe para desativar seleção de texto */
.no-select {
  user-select: none;
}
</style>



<script>
export default {
  name: "ImageCarousel",
  props: {
    images: {
      type: Array,
      required: true,
    },
    initialId: {
      type: [String, Number],
      default: null,
    },
    visibleItems: {
      type: Number,
      default: 3, // Número de imagens visíveis no carrossel
    },
    itemWidth: {
      type: Number,
      default: 120, // Largura de cada imagem em pixels
    },
    itemMargin: {
      type: Number,
      default: 16, // Margem lateral entre as imagens (em pixels)
    },
  },
  data() {
    return {
      selectedIndex: 0,
      scrollIndex: 0, // Índice de início para o deslocamento
    };
  },
  computed: {
    totalItemWidth() {
      // Soma a largura do item com as margens laterais
      return this.itemWidth + this.itemMargin * 2;
    },
    scrollOffset() {
      // Calcula o deslocamento horizontal considerando a largura total dos itens
      return this.scrollIndex * this.totalItemWidth;
    },
    canScrollLeft() {
      return this.scrollIndex > 0;
    },
    canScrollRight() {
      // Ajusta para considerar o tamanho do contêiner visível
      return (
        this.scrollIndex + this.visibleItems <
        this.images.length
      );
    },
  },
  methods: {
    scrollLeft() {
      if (this.canScrollLeft) {
        this.scrollIndex--;
      }
    },
    scrollRight() {
      if (this.canScrollRight) {
        this.scrollIndex++;
      }
    },
    selectImage(index) {
      this.selectedIndex = index;

      // Ajusta automaticamente o scrollIndex para centralizar a imagem
      if (index < this.scrollIndex) {
        this.scrollIndex = index;
      } else if (index >= this.scrollIndex + this.visibleItems) {
        this.scrollIndex = index - this.visibleItems + 1;
      }

      this.$emit("image-selected", this.images[index]);
    },
  },
  mounted() {
    if (this.initialId !== null) {
      const initialIndex = this.images.findIndex(
        (image) => image.id === this.initialId || image.name === this.initialId
      );
      if (initialIndex !== -1) {
        this.selectedIndex = initialIndex;

        // Ajusta o scroll para exibir a imagem inicial
        this.scrollIndex = Math.max(
          0,
          Math.min(initialIndex, this.images.length - this.visibleItems)
        );
      }
    }
  },

  watch: {
    images: {
      handler(newImages) {
        if (newImages && newImages.length > 0) {
          this.scrollIndex = 0; // Reseta o scroll para o início
          this.selectedIndex = 0; // Seleciona o primeiro item
        }
      },
      immediate: true, // Garante que a lógica seja aplicada ao carregar o componente
    },
  },


};
</script>

<style scoped>
/* Garante que os botões fiquem acima do carrossel */
button {
  z-index: 10;
}

/* Adiciona um leve fundo para garantir o contraste com as imagens */
button {
  background-color: rgba(0, 0, 0, 0.5); /* Fundo semi-transparente */
  color: white;
}

button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

/* Define altura e largura padrão para os botões */
button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}

/* Garante que o botão não ultrapasse o contêiner */
button:disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
